const READONLY_CONSOLE = "nEgpx32h_Lwx9RWxCu7Cqi-Jhn4OgcD9";
const READONLY_WONDERL = "sKqiGzdVnqWz2UfY2gL2_ptusEPzrhst";

function stripEmptyParagraphs(html = "") {
    return html.replace(
        /<p\b([^>]*)>(?:\s|&nbsp;|&#160;|<br\s*\/?>|<span\b[^>]*>(?:\s|&nbsp;|&#160;|<br\s*\/?>)*<\/span>)*<\/p>/ig,
        ""
    );
}

/**
 * Get language field of translations. AS STRING.
 *
 * @param {any[]} translations
 * @param {string} language
 * @param {string} field field of translations
 * @param {boolean} mapHtml map html with internal classes (headline1, headline2...)
 * @returns {string}
 */
module.exports.translate = function translate(translations, language, field, mapHtml = false, htmlClass = "") {
    if (!Array.isArray(translations)) return;

    for (const translation of translations) {
        if (translation.language?.code !== language && translation.languages_code?.code !== language && translation.languages_code !== language && translation.language !== language) continue;
        if(!translation[field]) return;
        if (mapHtml) return module.exports.map_html(translation[field], htmlClass);
        return translation[field];
    }

    return;
}


/**
 * Map common html elements to our styling
 * @param {string} input Input string
 * @returns replaced elements
 */
module.exports.map_html = function mapHTMLElements(input, htmlClass = "") {
    if (!input) return input;
    if (typeof input !== "string") return input;
    let replaced = input.replace(/<h1>/ig, '<h1 class="headline1 mb-4">');
    replaced  = replaced.replace(/<h1 (style=".*")>/ig, '<h1 class="headline1 mb-4" $1>');
    replaced  = replaced.replace(/<h2>/ig, '<h2 class="headline2 mb-3">');
    replaced  = replaced.replace(/<h2 (style=".*")>/ig, '<h2 class="headline2 mb-3" $1>');
    replaced  = replaced.replace(/<h3>/ig, '<h3 class="headline3 mb-2">');
    replaced  = replaced.replace(/<h3 (style=".*")>/ig, '<h3 class="headline3 mb-2" $1>');
    replaced  = replaced.replace(/<h4>/ig, '<h4 class="headlineGeneralText mb-2">');
    replaced  = replaced.replace(/<h4 (style=".*")>/ig, '<h4 class="eadlineGeneralText mb-2" $1>');
    replaced  = replaced.replace(/<ol>/ig, '<ol style="list-style: decimal; margin-left: 1.5em; margin-top: 1em; margin-bottom: 1em;">');
    replaced  = replaced.replace(/<ul>/ig, '<ul style="list-style: initial; margin-left: 1.5em; margin-top: 1em; margin-bottom: 1em;">');
    replaced  = replaced.replace(/<hr>/ig, '<hr style=" margin-top: 1em; margin-bottom: 1em;">');
    replaced  = replaced.replace(/<p>/ig, '<p class="generalText2 mb-4">');
    replaced  = replaced.replace(/<p styl/ig, '<p class="generalText2 mb-4" styl');
    // replaced  = replaced.replace(/console.spotliodata.com/ig, "console.spotliowebsites.com");
    replaced  = replaced.replace(/<span class="cta-button">(.*?)<\/span>/ig, function (match, inner) {
        if (inner.indexOf("<a href=") !== -1)  return inner.replace("<a href=", '<a class="cta-button" href=');
        return match;
    });
    replaced  = replaced.replace(/<span class="cta-secondary-button">(.*?)<\/span>/ig, function (match, inner) {
        if (inner.indexOf("<a href=") !== -1)  return inner.replace("<a href=", '<a class="cta-secondary-button" href=');
        return match;
    });
    replaced  = replaced.replace(/<img src="(.*?)"/ig, function (match, src) {
        src = src.replace(READONLY_WONDERL, READONLY_CONSOLE) // switch tokens to production
        if (src.includes(":8057/assets")) src = `https://console.spotliowebsites.com/assets/${src.split("/assets/")[1]}` // switch assets to production
        if (src.includes(":8056/assets")) src = `https://console.spotliowebsites.com/assets/${src.split("/assets/")[1]}` // switch assets to production
        return `<img class="mt-4 mb-4" src="${src}"`
    });

    replaced = stripEmptyParagraphs(replaced);
    return `<div class="html ${htmlClass}">`+replaced+`</div>`;
}